import { useEffect, useState } from "react"

import { isClientSide } from "@utils"

const BENTO_BOX_CAROUSEL_COLUMN_COUNTS = {
  0: 1,
  768: 2,
  1024: 3,
}

const useCarousel = (isCarousel: boolean, itemsCount: number): {
  carouselOffset?: number,
  isCarouselDisabledLeft?: boolean,
  isCarouselDisabledRight?: boolean,
  moveCarouselLeft?: () => void,
  moveCarouselRight?: () => void,
} => {
  if (!isCarousel || itemsCount === 0) return {}

  const [carouselOffset, setCarouselOffset] = useState<number>(0)

  const getCarouselColumnsCount = () => {
    if (!isClientSide() || window.innerWidth >= 1024) return BENTO_BOX_CAROUSEL_COLUMN_COUNTS[1024]
    if (window.innerWidth >= 768) return BENTO_BOX_CAROUSEL_COLUMN_COUNTS[768]
    return BENTO_BOX_CAROUSEL_COLUMN_COUNTS[0]
  }

  const moveCarouselLeft = () => {
    setCarouselOffset(_offset => {
      const isAble = _offset < 0
      if (!isAble) return _offset
      const newOffset = _offset + getCarouselColumnsCount()
      return newOffset >= 0 ? 0 : newOffset
    })
  }

  const moveCarouselRight = () => {
    setCarouselOffset(_offset => {
      const carouselColumnsCount = getCarouselColumnsCount()
      const minRight = itemsCount * -1 + carouselColumnsCount
      const isAble = _offset > minRight
      if (!isAble) return _offset
      const newOffset = _offset - carouselColumnsCount
      return newOffset <= minRight ? minRight : newOffset
    })
  }

  useEffect(() => {
    if (!isClientSide()) return

    window.addEventListener("resize", getCarouselColumnsCount)

    return () => {
      window.removeEventListener("resize", getCarouselColumnsCount)
    }
  }, [])

  return {
    carouselOffset,
    isCarouselDisabledLeft: carouselOffset === 0,
    isCarouselDisabledRight: carouselOffset === itemsCount * -1 + getCarouselColumnsCount(),
    moveCarouselLeft,
    moveCarouselRight,
  }
}

export default useCarousel
